export const PLAYER_EVENTS = {
    "SPIN_POSITION_SET": "SPIN_POSITION_SET",
};